import { useLanguage, t } from "../../../i18n";
import React from "react";
import { Button } from "react-bootstrap";
import { HiOutlineBars3 } from "react-icons/hi2";
import LocationBadge from "../../common/Badge/LocationBadge/LocationBadge";
import { useLocation } from "../../../features/location/context/LocationContext";
import "./Header.css";
import Logo from "../../common/Logo/Logo";
export default function Header({
  onMenuClick
}) {
  useLanguage();
  const {
    detectedCity,
    isDetectingLocation
  } = useLocation();
  const badgeCity = detectedCity || "";
  return <header className="bb-mobile-header">
      <div className="bb-mobile-header__left">
        <div className="bb-mobile-header__logo">
          <Logo />
        </div>
      </div>

      <div className="bb-mobile-header__right">
        <div className="bb-mobile-header__location">
          <LocationBadge city={isDetectingLocation ? "Detecting..." : badgeCity || "Location unavailable"} />

        </div>

        <Button variant="light" className="bb-mobile-header__menu-btn" aria-label={t("Open menu")} onClick={onMenuClick}>

          <HiOutlineBars3 />
        </Button>
      </div>
    </header>;
}
